import React, { useState } from "react";
import JsonData1 from "../../data/ActualData.json";
import JsonData2 from "../../data/ForecastAccuracyandSpendEvolution.json";
import SingleBarChart from "../../chats/SingleBarChart";
import PowerBiReport from "./PowerBiReport";
import ChatPopup from "../Model/ChatPopup";
import PlotlyGraph from "../../chats/PlotlyGrapgh";
import RadialBarChart from "../../chats/RadialBarChart";
import { FaExpand } from "react-icons/fa";
import ReportPopUp from "../../Model/ReportPopUp";

const CircularProgress = ({ percentage }) => {
  const circumference = 2 * Math.PI * 20;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return (
    <div className="relative inline-flex items-center justify-center">
      <svg className="transform -rotate-90 w-16 h-16">
        <circle
          className="text-gray-200"
          strokeWidth="4"
          stroke="currentColor"
          fill="transparent"
          r="30"
          cx="32"
          cy="32"
        />
        <circle
          className="text-green-600"
          strokeWidth="4"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          stroke="currentColor"
          fill="transparent"
          r="30"
          cx="32"
          cy="32"
        />
      </svg>
      <span className="absolute text-sm font-semibold">{percentage}%</span>
    </div>
  );
};

export const Details = ({ dataItem, totalMargin }) => {
  const [data, setData] = useState(dataItem);

  const urlParams = new URLSearchParams(window.location.search);
  const name = urlParams.get("category");

  console.log(data);

  return (
    <div style={{ padding: "1rem", zoom: ".9" }}>
      <div>
        <div
          style={{ background: "#1453A0", color: "white" }}
          className="hidden md:grid md:grid-cols-[2fr,3fr,3fr,4fr,2fr,1fr,.5fr] gap-4 p-4 bg-gray-100 rounded-t-lg text-sm font-medium text-gray-600"
        >
          <div>Particulars</div>
          <div>KeyInsights</div>
          <div>Recommendations</div>
          <div>Value Creation</div>
          <div>Functions</div>
          <div>Status</div>
          <div></div>
        </div>

        <div style={{ display: "grid", gap: "1rem" }}>
          {data && (
            <>
              <div className="flex flex-col md:grid md:grid-cols-[2fr,3fr,3fr,4fr,2fr,1fr,.5fr] gap-4 p-4 border-b border-gray-200 hover:bg-gray-50 bg-white rounded-lg shadow-sm">
                <div className="flex flex-col sm:flex-row gap-4 md:flex-row">
                  <div className="flex-1">
                    <h5 className="font-medium text-gray-900">
                      {data.Particulars}
                    </h5>
                    <p className="text-sm text-gray-500">{data.ModuleName}</p>
                    <div className="mt-1">
                      <div className="flex flex-wrap items-center gap-2 text-sm text-gray-600">
                        <span>Segment: {data.segment || "N/A"}</span>
                      </div>

                      <div className="flex flex-wrap items-center gap-2 text-sm text-gray-600">
                        <span>Market: {data.segment || "N/A"}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="pr-4 md:mt-0">
                  <p className="text-sm text-gray-600">{data.KeyInsights}</p>
                </div>

                <div className="pr-4 md:mt-0">
                  <p className="text-sm text-gray-600">
                    {data.Recommendations}
                  </p>
                </div>

                <div className="md:mt-0">
                  <div className="flex items-start gap-4">
                    {/* <SingleBarChart AvgDaysAsPerTerms={item.AvgDaysAsPerTerms} ActualDaysToPay={item.ActualDaysToPay}/> */}
                    {/* <PlotlyGraph AvgDaysAsPerTerms={data["Total Sped (Actual)"]} ActualDaysToPay={item["Total Spend (Forecast)"]}/> */}
                    <RadialBarChart
                      valueItem={data.TotalValue.toFixed(1)}
                      percentage={
                        ((data.TotalValue / totalMargin) * 100).toFixed(0) || 0
                      }
                    />

                    <div className="text-sm text-gray-600">
                      {data &&
                        data.OtherDetails &&
                        data.OtherDetails.map((detail, index) => (
                          <div key={index}>
                            {detail.name} : {detail.value}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>

                <div
                  style={{ display: "grid", alignContent: "baseline" }}
                  className="gap-1"
                >
                  {data &&
                    data.Functions &&
                    data.Functions.map((detail, index) => (
                      <div key={index}>
                        <span
                          style={{
                            borderRadius: "7px",
                            background: "#eee",
                            color: "black",
                            paddingTop: "10px",
                            paddingBottom: "10px",
                            paddingLeft: "10px",
                            paddingRight: "10px",
                          }}
                          className="inline-flex items-center text-xs font-medium bg-gray-100 text-gray-800"
                        >
                          {detail.name}
                        </span>
                      </div>
                    ))}
                </div>

                <div
                  className={`text-sm font-medium md:mt-0 ${
                    data.Status === "To be reviewed"
                      ? "text-green-600"
                      : data.Status === "Action initiated"
                      ? "text-blue-600"
                      : "text-yellow-600"
                  }`}
                >
                  {data.Status}
                </div>

                <div className="text-sm font-medium md:mt-0">
                  <ChatPopup />
                </div>
              </div>
            </>
          )}
        </div>

        <div
          style={{ position: "relative", minHeight: "500px" }}
          className="flex flex-col md:grid gap-4 p-4 border-b border-gray-200 hover:bg-gray-50 bg-white rounded-lg shadow-sm  mt-4"
        >
          <span style={{ position: "absolute", right: "8px", top: "3px" }}>
            <ReportPopUp
              reportid={data.ReportID === "1" ? 101 : parseInt(data.ReportID)}
              pagename={data.PageName}
            />
          </span>

          <PowerBiReport
            reportid={data.ReportID === "1" ? 101 : parseInt(data.ReportID)}
            pagename={data.PageName}
          />
        </div>
      </div>
    </div>
  );
};
